import { render, staticRenderFns } from "./YearEndDistributions.vue?vue&type=template&id=fe1024e8"
import script from "./YearEndDistributions.vue?vue&type=script&lang=js"
export * from "./YearEndDistributions.vue?vue&type=script&lang=js"
import style0 from "./YearEndDistributions.vue?vue&type=style&index=0&id=fe1024e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports